import { enGB, fr } from "date-fns/locale";
import { format } from "date-fns";
import { FedexScanEvent } from "@/types/fedex.type";
import { TimelineItem } from "@/components/ui/customs/timeline-item";

type TrackingDetailElemProps = {
  index: number;
  scanEvent: FedexScanEvent;
  scanEventsLength: number;
  locale: string;
};

export const TrackingDetailElem = ({
  index,
  scanEvent,
  scanEventsLength,
  locale,
}: TrackingDetailElemProps) => (
  <TimelineItem
    dateLabel={format(scanEvent.date, "EEEE dd/MM/yyyy", {
      locale: locale === "fr" ? fr : enGB,
    })}
    timeLabel={format(scanEvent.date, "HH:mm")}
    title={scanEvent.eventDescription}
    subtitle={scanEvent.exceptionDescription || undefined}
    location={
      [scanEvent.scanLocation.city, scanEvent.scanLocation.countryCode]
        .filter(Boolean)
        .join(", ") || undefined
    }
    isLast={index === scanEventsLength - 1}
  />
);
